<template>
  <div v-if="template && instance && instance.currentLevel">
    <v-progress-linear class="progress-border" v-if="template.useBelts"
      :color="getBeltColorForProgress(instance.currentLevel)" height="20" :value="instance.progress" style="color:white"
      striped>
      <template v-slot:default="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
    <v-progress-linear class="progress-border" v-else
      :color="template.colors && template.colors[instance.currentLevel] ? template.colors[instance.currentLevel] : getColor('light')"
      height="20" :value="instance.progress" striped
      :style="(template.colors && template.colors[instance.currentLevel] ? 'color:white;' : '')">
      <template v-slot:default="{ value }">
        <strong> {{instance.currentLevel}}: {{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
  </div>
  <div v-else-if="instance && instance.currentLevel">
    <v-progress-linear class="progress-border" v-if="instance.useBelts"
      :color="instance.color ? instance.color : getBeltColorForProgress(instance.level)" height="20" :value="100"
      style="color:white" striped>
      <template v-slot:default="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
    <v-progress-linear class="progress-border" v-else
      :color="instance.color ? instance.color : getColor(instance.level)" height="20" :value="100" style="color:white"
      striped>
      <template v-slot:default="{ value }">
        <strong style="color:#D7DBDD">{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
  </div>
  <div v-else>
    <span class="text-h6">{{ $t('message.no_level_assigned')}}</span>
  </div>
</template>

<script>
export default {
  props: ["instance","template"],
  data() {
    return {
      toolTip: null
    };
  },
  methods: {},
  created() {
  },
  computed: {
  }
};
</script>

<style scoped>
.progress-border {
  border: 1px solid #D7DBDD;
}
</style>